import { render, staticRenderFns } from "./appointmentsAndReviews.vue?vue&type=template&id=4b3b0038&"
import script from "./appointmentsAndReviews.vue?vue&type=script&lang=js&"
export * from "./appointmentsAndReviews.vue?vue&type=script&lang=js&"
import style0 from "./appointmentsAndReviews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports